<!-- Navbar Toggler -->
<div class="d-flex justify-content-between">
	<div class="d-flex align-items-center"
		[ngClass]="{'justify-content-between' : loggedinUser.isAdmin}">
		<button pmd-btn
			pmdRipple
			pmd-btn-fab
			pmd-btn-flat
			size="xs"
			(click)="showSideBar()"
			class="pmd-sidebar-toggle d-xl-none pmd-btn-rounded ms-2"
			aria-label="Press enter to open the left sidebar navigation">
			<i class="material-symbols-outlined md-dark">menu</i>
		</button>
		<!-- Navbar brand -->
		<ng-container *ngIf="router.url === '/purchase-manager/analytics-dashboard' && loggedinUser.isLeadAdmin">
		    <div class="d-flex align-items-center justify-content-start gap-2">
		        <svg xmlns="http://www.w3.org/2000/svg"
		            width="24"
		            height="24"
		            viewBox="0 0 24 24"
		            fill="none"
		            stroke="currentColor"
		            stroke-width="2"
		            stroke-linecap="round"
		            stroke-linejoin="round"
		            class="lucide lucide-chart-column h-8 w-8 text-blue-600 text-success"
		            data-fg-d3bl5="0.8:1.6074:/src/app/App.tsx:31:13:1309:47:e:BarChart3::::::C2Ja"
		            data-fgid-d3bl5=":r4:">
		            <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
		            <path d="M18 17V9"></path>
		            <path d="M13 17V5"></path>
		            <path d="M8 17v-3"></path>
		        </svg>
		        <h1 class="mb-0 text-dark">Purchase Manager Analytics</h1>
		    </div>
		</ng-container>
		<div class="navbar-multi-select-entity position-relative"
			joyrideStep="firstStep"
			[stepContent]="customContent01"
			[nextTemplate]="nextButton"
			*ngIf="!loggedinUser.isAdmin && !(router.url === '/purchase-manager/analytics-dashboard' && loggedinUser.isLeadAdmin)">

			<!-- Multiple selection at a time single parent company with multiple outlets (updated) -->
			<ng-container *ngIf="canShowMultiSelectCompanyDropdown()">
				<pmd-input-group-outline>
					<ng-select groupBy="group"
						id="select-entity"
						name="select-entity"
						[formControl]="selectedEntities"
						appearance="outline"
						[items]="entities"
						[multiple]="true"
						pmdTextField
						placeholder="Select Entity"
						[clearable]="false"
						[clearSearchOnAdd]="true"
						bindLabel="name"
						class="pmd-select pmd-select-outline"
						(change)="onEntityChange({'isMultiSelect': true})"
						(open)="onSelectionOpen()"
						(close)="onEntitySelectionClose({'isMultiSelect': true})"
						[closeOnSelect]="false">

						<!-- Group header with Select All + indeterminate checkbox -->
						<ng-template ng-optgroup-tmp
							let-item="item">
							<div class="d-flex gap-2 align-items-center text-secondary fs-14">
								<div class="form-check flex-1">
									<input type="checkbox"
										class="form-check-input"
										[checked]="isGroupChecked(item.group)"
										[indeterminate]="isGroupIndeterminate(item.group)"
										(change)="onGroupSelectionChange({ checked: $event.target.checked }, item.group)"
										id="group-{{item.group}}-checkbox" />
									<label class="form-check-label flex-1 ms-2"
										for="group-{{item.group}}-checkbox">
										<svg width="20"
											height="21"
											viewBox="0 0 16 17"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M5.00004 7.83333H3.06671C2.69334 7.83333 2.50665 7.83333 2.36405 7.906C2.23861 7.96991 2.13662 8.0719 2.0727 8.19734C2.00004 8.33995 2.00004 8.52663 2.00004 8.9V14.5M11 7.83333H12.9334C13.3067 7.83333 13.4934 7.83333 13.636 7.906C13.7615 7.96991 13.8635 8.0719 13.9274 8.19734C14 8.33995 14 8.52663 14 8.9V14.5M11 14.5V4.63333C11 3.8866 11 3.51323 10.8547 3.22801C10.7269 2.97713 10.5229 2.77316 10.272 2.64532C9.98681 2.5 9.61344 2.5 8.86671 2.5H7.13337C6.38664 2.5 6.01327 2.5 5.72805 2.64532C5.47717 2.77316 5.2732 2.97713 5.14537 3.22801C5.00004 3.51323 5.00004 3.8866 5.00004 4.63333V14.5M14.6667 14.5H1.33337M7.33337 5.16667H8.66671M7.33337 7.83333H8.66671M7.33337 10.5H8.66671"
												stroke="#C99E01"
												stroke-width="1.2"
												stroke-linecap="round"
												stroke-linejoin="round" />
										</svg>
										{{item.group}}
									</label>
								</div>
							</div>
						</ng-template>

						<!-- Individual item option -->
						<ng-template ng-option-tmp
							let-item="item">
							<div class="pmd-checkbox-option"
								[ngClass]="{'isDisabledEntity': item.disabled}">
								<pmd-checkbox [state]="item.isSelected ? 'checked' : ''"
									[checked]="item.isSelected ? true : false"
									class="flex-1"
									[ngClass]="{'isDisabledEntity z-index-minus': item.disabled}">
									{{item.name}}
								</pmd-checkbox>
							</div>
						</ng-template>

						<!-- Selected items display -->
						<ng-template ng-multi-label-tmp
							let-items="items"
							let-clear="clear">
							<div class="ng-value"
								*ngFor="let item of items | slice:0:2">
								<span class="ng-value-icon"
									(click)="clear(item)"
									aria-hidden="true">×</span>
								<span class="ng-value-label">{{item.name}}</span>
							</div>
							<div class="ng-value bg-white ts-more"
								*ngIf="items.length > 2">
								<span class="ng-value-label">+{{items.length - 2}} more...</span>
							</div>
						</ng-template>
					</ng-select>
				</pmd-input-group-outline>
			</ng-container>

			<!-- single entity dropdown (updated) -->
			<ng-container *ngIf="canShowSingleEntityDropdown() && singleSelectEntities?.length">
				<pmd-input-group-outline>
					<ng-select id="select-entity"
						groupBy="group"
						name="select-entity"
						[formControl]="selectedEntities"
						appearance="outline"
						[items]="singleSelectEntities"
						pmdTextField
						[multiple]="false"
						placeholder="Select Entity"
						[clearable]="false"
						[clearSearchOnAdd]="true"
						bindLabel="name"
						class="pmd-select pmd-select-outline"
						(change)="onEntityChange({'isSingleSelectEntity': true})"
						(close)="onEntitySelectionClose({'isSingleSelectEntity': true})"
						(open)="onSelectionOpen()"
						[closeOnSelect]="true"
						#singleSelectionDropdown>
						<ng-template ng-optgroup-tmp
							let-item="item">
							<div class="d-flex gap-2 align-items-center text-secondary fs-14">
								<svg width="20"
									height="21"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M5.00004 7.83333H3.06671C2.69334 7.83333 2.50665 7.83333 2.36405 7.906C2.23861 7.96991 2.13662 8.0719 2.0727 8.19734C2.00004 8.33995 2.00004 8.52663 2.00004 8.9V14.5M11 7.83333H12.9334C13.3067 7.83333 13.4934 7.83333 13.636 7.906C13.7615 7.96991 13.8635 8.0719 13.9274 8.19734C14 8.33995 14 8.52663 14 8.9V14.5M11 14.5V4.63333C11 3.8866 11 3.51323 10.8547 3.22801C10.7269 2.97713 10.5229 2.77316 10.272 2.64532C9.98681 2.5 9.61344 2.5 8.86671 2.5H7.13337C6.38664 2.5 6.01327 2.5 5.72805 2.64532C5.47717 2.77316 5.2732 2.97713 5.14537 3.22801C5.00004 3.51323 5.00004 3.8866 5.00004 4.63333V14.5M14.6667 14.5H1.33337M7.33337 5.16667H8.66671M7.33337 7.83333H8.66671M7.33337 10.5H8.66671"
										stroke="#C99E01"
										stroke-width="1.2"
										stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
								{{item.group}}
							</div>
						</ng-template>
						<ng-template ng-option-tmp
							let-item="item">
							<div class="d-flex align-items-center justify-content-between ng-value-label"
								placement="left">
								<span class="flex-1">
									{{item.name}}
								</span>
								<svg width="20"
									*ngIf="item.isSelected"
									height="21"
									viewBox="0 0 15 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M4.6875 7L6.5625 8.875L10.3125 5.125M13.75 7C13.75 10.4518 10.9518 13.25 7.5 13.25C4.04822 13.25 1.25 10.4518 1.25 7C1.25 3.54822 4.04822 0.75 7.5 0.75C10.9518 0.75 13.75 3.54822 13.75 7Z"
										stroke="#564400"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
							</div>
						</ng-template>
					</ng-select>
				</pmd-input-group-outline>
				<div class="static-tooltip-block"
					*ngIf="isTooltipStatic && router.url.includes('/invoice/upload') && !['/tally-config'].includes(router.url)">
					Please choose any single entity to upload invoice
				</div>
			</ng-container>

			<!-- single select company dropdown (updated) -->
			<ng-container *ngIf="canShowSingleCompanyDropdown()">
				<pmd-input-group-outline>
					<ng-select id="select-entity"
						name="select-entity"
						[formControl]="selectedEntities"
						appearance="outline"
						[items]="singleSelectCompanies"
						pmdTextField
						[multiple]="false"
						placeholder="Select Entity"
						[clearable]="false"
						[clearSearchOnAdd]="true"
						bindLabel="name"
						class="pmd-select pmd-select-outline"
						(change)="onEntityChange({'isSingleSelectCompany': true})"
						(close)="onSelectClose()"
						(open)="onSelectionOpen()"
						[closeOnSelect]="true"
						#singleSelectionCompanyDropdown>
						<ng-template ng-option-tmp
							let-item="item">
							<div class="d-flex align-items-center ng-value-label justify-content-between">
								<div class="d-flex gap-2 align-items-center">
									<svg width="18"
										height="16"
										viewBox="0 0 16 14"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M5.00016 6.33333H3.06683C2.69346 6.33333 2.50678 6.33333 2.36417 6.406C2.23873 6.46991 2.13674 6.5719 2.07283 6.69734C2.00016 6.83995 2.00016 7.02663 2.00016 7.4V13M11.0002 6.33333H12.9335C13.3069 6.33333 13.4935 6.33333 13.6362 6.406C13.7616 6.46991 13.8636 6.5719 13.9275 6.69734C14.0002 6.83995 14.0002 7.02663 14.0002 7.4V13M11.0002 13V3.13333C11.0002 2.3866 11.0002 2.01323 10.8548 1.72801C10.727 1.47713 10.523 1.27316 10.2722 1.14532C9.98693 1 9.61357 1 8.86683 1H7.1335C6.38676 1 6.01339 1 5.72818 1.14532C5.47729 1.27316 5.27332 1.47713 5.14549 1.72801C5.00016 2.01323 5.00016 2.3866 5.00016 3.13333V13M14.6668 13H1.3335M7.3335 3.66667H8.66683M7.3335 6.33333H8.66683M7.3335 9H8.66683"
											stroke="#373737"
											stroke-width="1.2"
											stroke-linecap="round"
											stroke-linejoin="round" />
									</svg>
									<span class="flex-1">
										{{item.name}}
									</span>
								</div>
								<svg width="20"
									*ngIf="item.isSelected"
									height="21"
									viewBox="0 0 15 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M4.6875 7L6.5625 8.875L10.3125 5.125M13.75 7C13.75 10.4518 10.9518 13.25 7.5 13.25C4.04822 13.25 1.25 10.4518 1.25 7C1.25 3.54822 4.04822 0.75 7.5 0.75C10.9518 0.75 13.75 3.54822 13.75 7Z"
										stroke="#564400"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
							</div>
						</ng-template>
					</ng-select>
				</pmd-input-group-outline>
				<div class="static-tooltip-block"
					*ngIf="isTooltipStatic">
					Please choose any single company to view bank account details
				</div>
			</ng-container>
		</div>
		<ng-template #customContent01>
			<div class="p-4">
				<h5 class="text-dark fw-bold">1/<span class="text-desc fw-medium">4</span> My Entity - 1</h5>
				<p class="fs-14 mb-0">My Entity-1 was created by Petpooja Purchase. You can access all companies and
					their respective entities using this dropdown. To rename My Entity-1, go to Settings.</p>
			</div>
		</ng-template>
		<ng-template #prevButton>
			<button type="button"
				pmdRipple
				pmd-btn-outline
				color="dark"
				class="w-100">Back</button>
		</ng-template>
		<ng-template #nextButton>
			<button type="button"
				pmdRipple
				pmd-btn
				color="secondary"
				class="w-100">Next</button>
		</ng-template>

	</div>
	<pmd-navbar-right-icon class="d-flex align-items-center pf-navbar-right-icon gap-3">
		<form class="form-inline w-100"
			autocomplete="off"
			*ngIf="loggedinUser.isAdmin && !['/push-to-petpooja', '/tally-config', '/push-to-retail-pos', '/push-to-tally', '/push-to-petpooja/manage-poss-tags', '/push-to-retail-pos/manage-invoice-tags'].includes(router.url)"
			class="d-none d-lg-block flex-1">
			<div class="d-flex align-items-center gap-3">
				<!-- Company Metadata Counts for Admin in MyQueue -->
				<div class="d-flex gap-2 align-items-center"
					*ngIf="loggedinUser.isAdmin && invoiceActiveGroup === 'assigned' && router.url === '/invoice'">
					<span [pmdTooltip]="'Total number of companies allocated to you'"
						class="pmd-btn btn-sm py-1 fw-medium text-xs bg-light-warning border text-warning">
						Companies: <b>{{companyMetadata.totalAllocatedCompanies}}</b>
					</span>
					<span [pmdTooltip]="'Total number of pending invoices across all allocated companies'"
						class="pmd-btn btn-sm py-1 fw-medium text-xs bg-light-warning border text-warning">
						Pending Invoices: <b>{{companyMetadata.totalPendingInvoices}}</b>
					</span>
				</div>
				<div class="d-flex gap-2 align-items-center mb-3 mb-lg-0 px-lg-0 me-3">
					<label for="company-name"
						class="col-form-label pb-0">Company</label>
					<ng-select [searchable]="true"
						(search)="onCompanySearch($event)"
						[clearable]="false"
						labelForId="company-name"
						[markFirst]="true"
						[items]="parentCompanyList"
						[formControl]="selectedCompany"
						bindLabel="name"
						bindValue="id"
						appearance="outline"
						class="pmd-select pmd-select-outline khr-header-entity-dropdown "
						placeholder="Company"
						name="companyNameFilter"
						ng-click="active!= ng-select-opened"
						(open)="getUpdatedCountForCompanies()"
						(close)="onCompanyDropdownClose()">
						<ng-container *ngIf="invoiceActiveGroup === 'assigned' && router.url === '/invoice'">
							<!-- Selected value display -->
							<ng-template ng-label-tmp
								let-company="item">
								<span>
									{{ company.name }}
								</span>
								<!-- <span class="count-pending-invoice">
									{{ company.totalPendingInvoices || 0 }}
								</span> -->

							</ng-template>

							<!-- Dropdown options -->
							<ng-template ng-option-tmp
								let-company="item">
								<!-- {{ company.name }} ({{ company.totalPendingInvoices || 0 }}) -->
								<span>
									{{ company.name }}
								</span>
								<span class="count-pending-invoice"
									pmdTooltip="Pending Invoices"
									placement="bottom">
									{{ company.totalPendingInvoices || 0 }}
								</span>
							</ng-template>
						</ng-container>
					</ng-select>
				</div>
				<div class="d-flex gap-2 align-items-center"
					*ngIf="loggedinUser.isAdmin && !['/push-to-petpooja', '/tally-config', '/push-to-retail-pos', '/push-to-tally'].includes(router.url)">
					<label for="select-entity"
						class="d-none d-lg-block">Entity</label>
					<ng-select groupBy="group"
						id="select-entity"
						name="select-entity"
						[items]="entities"
						[formControl]="selectedEntities"
						appearance="outline"
						[multiple]="true"
						pmdTextField
						placeholder="Select Entity"
						[clearable]="false"
						[clearSearchOnAdd]="true"
						bindLabel="name"
						class="pmd-select pmd-select-outline khr-header-entity-dropdown-admin"
						(close)="onEntitySelectionCloseAdmin()"
						(change)="onEntityChangeAdmin()"
						(open)="onSelectionOpenAdmin(); getCompanyList()"
						[closeOnSelect]="false">
						<ng-template ng-option-tmp
							let-item="item">
							<div class="pmd-checkbox-option"><span class="material-icons pmd-option-check"></span>
								<div class="d-flex justify-content-between w-100 align-items-center">
									<span>{{ item.name }}</span>
									<span class="count-pending-invoice"
										pmdTooltip="Pending Invoices"
										placement="bottom"
										*ngIf="item.name !== 'All' && invoiceActiveGroup === 'assigned' && router.url === '/invoice'">
										{{ item.totalPendingInvoices || 0 }}
									</span>
								</div>
							</div>

							<!-- {{item.name}} {{ item.name !== 'All' && invoiceActiveGroup === 'assigned' && router.url
								=== '/invoice'
								? '(' + (item.totalPendingInvoices || 0) + ')'
								: '' }}</div> -->
						</ng-template>


						<!-- <ng-template ng-multi-label-tmp
							let-items="items"
							let-clear="clear">
							<div class="ng-value"
								*ngFor="let item of items | slice:0:1">
								<span class="ng-value-label">{{item.name}}</span>
							</div>
							<div class="ng-value ts-more"
								*ngIf="items.length >2">
								<span class="ng-value-label">+{{items.length - 1}} more...</span>
							</div>
						</ng-template> -->
						<ng-template ng-multi-label-tmp
							let-items="items"
							let-clear="clear">
							<ng-container *ngIf="isAllSelected(items); else notAllSelected">
								<div class="ng-value">
									<span class="ng-value-label">All</span>
								</div>
							</ng-container>

							<ng-template #notAllSelected>
								<div class="ng-value"
									*ngFor="let item of items | slice:0:1">
									<span class="ng-value-label">{{item.name}}</span>
								</div>
								<div class="ng-value ts-more"
									*ngIf="items.length > 1">
									<span class="ng-value-label">+{{items.length - 1}} more...</span>
								</div>
							</ng-template>
						</ng-template>
					</ng-select>
				</div>
			</div>
		</form>

		<ng-container *ngIf="PEFormGroup && ['/push-to-petpooja'].includes(router.url)">
			<form [formGroup]="">
				<div class="switch-toggle toggle_secondary switch-expenditure"
					container="body"
					placement="bottom">
					<div class="toggle-button-cover">
						<div class="button-cover">
							<div class="button b2">
								<input type="checkbox"
									id="pe-checkbox"
									[formControl]="invoiceFieldType"
									(change)="setFieldType();"
									tabindex="0"
									[checked]="peF.invoiceFieldType.value?.toLowerCase() == appGlobals.EXPENSE.toLowerCase() ? true : false"
									class="checkbox" />
								<div class="knobs">
									<span>Purchase</span>
								</div>
								<div class="layer"></div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</ng-container>
		<div *ngIf="(loggedinUser.isOwner || loggedinUser.isOutlet) && !router.url.includes('upload')"
			class="search-upload position-relative top-0 end-0">
			<button type="button"
				pmdRipple
				pmd-btn-outline
				color="secondary"
				[disabled]="!authService.secondaryOwnerCanAccess('/invoice/upload')"
				[routerLink]="['/invoice/upload']"
				class="pmd-btn-outline-secondary py-2"
				joyrideStep="fourthStep"
				[stepContent]="customContent04"
				[prevTemplate]="prevButton04"
				[doneTemplate]="uploadNowBtn04"
				(done)="redirectToUploadInvoice()">
				<ng-template #customContent04>
					<div class="p-4">
						<h5 class="text-dark fw-bold">4/<span class="text-desc fw-medium">4</span> Upload Invoices</h5>
						<p class="fs-14 mb-1"> You can upload invoices from any screen by clicking this handy button.
						</p>
					</div>
				</ng-template>
				<ng-template #prevButton04>
					<button type="button"
						pmdRipple
						pmd-btn-outline
						color="dark"
						class="w-100">Back</button>
				</ng-template>
				<ng-template #uploadNowBtn04>
					<button type="button"
						pmdRipple
						pmd-btn
						color="secondary"
						class="w-100">Upload Now</button>
				</ng-template>
				<span class="d-none d-xl-block">Upload Invoice</span>
				<span class="d-xl-none"><svg width="28"
						height="25"
						viewBox="0 0 28 25"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M1.32146 16.0651C1.43223 16.0651 1.5419 16.0876 1.64423 16.1313C1.74656 16.175 1.83954 16.239 1.91786 16.3198C1.99618 16.4005 2.05831 16.4964 2.1007 16.6018C2.14309 16.7073 2.1649 16.8204 2.1649 16.9346V21.2798C2.1649 21.7407 2.34252 22.1827 2.65868 22.5087C2.97484 22.8346 3.40365 23.0177 3.85077 23.0177H24.0852C24.5324 23.0177 24.9612 22.8346 25.2773 22.5087C25.5935 22.1827 25.7711 21.7407 25.7711 21.2798V16.9346C25.7672 16.8179 25.7861 16.7017 25.8267 16.5928C25.8673 16.4838 25.9288 16.3844 26.0075 16.3005C26.0861 16.2166 26.1804 16.1498 26.2846 16.1042C26.3888 16.0586 26.5008 16.0352 26.6141 16.0352C26.7273 16.0352 26.8393 16.0586 26.9435 16.1042C27.0477 16.1498 27.142 16.2166 27.2206 16.3005C27.2993 16.3844 27.3608 16.4838 27.4014 16.5928C27.442 16.7017 27.4609 16.8179 27.457 16.9346V21.2798C27.457 21.7364 27.3698 22.1885 27.2003 22.6103C27.0308 23.0321 26.7823 23.4154 26.4691 23.7383C26.156 24.0611 25.7841 24.3172 25.3749 24.4919C24.9657 24.6667 24.5272 24.7566 24.0842 24.7566H3.85077C3.40786 24.7566 2.96928 24.6667 2.56008 24.4919C2.15088 24.3172 1.77907 24.0611 1.46588 23.7383C1.15269 23.4154 0.904259 23.0321 0.734762 22.6103C0.565266 22.1885 0.478027 21.7364 0.478027 21.2798L0.478027 16.9346C0.478027 16.8204 0.499843 16.7073 0.54223 16.6018C0.584617 16.4964 0.646744 16.4005 0.725064 16.3198C0.803385 16.239 0.896365 16.175 0.998695 16.1313C1.10103 16.0876 1.2107 16.0651 1.32146 16.0651Z"
							fill="#E6B401" />
						<path
							d="M13.3751 0.849045C13.4534 0.768118 13.5465 0.703913 13.6489 0.660106C13.7514 0.616299 13.8612 0.59375 13.9721 0.59375C14.083 0.59375 14.1928 0.616299 14.2953 0.660106C14.3977 0.703913 14.4908 0.768118 14.5691 0.849045L19.6277 6.06372C19.7084 6.14402 19.7727 6.24007 19.817 6.34628C19.8613 6.45248 19.8846 6.56671 19.8856 6.6823C19.8865 6.79789 19.8652 6.91253 19.8227 7.01951C19.7803 7.1265 19.7176 7.2237 19.6383 7.30544C19.559 7.38718 19.4647 7.45182 19.3609 7.49558C19.2571 7.53935 19.1459 7.56138 19.0338 7.56037C18.9216 7.55936 18.8108 7.53533 18.7078 7.4897C18.6048 7.44407 18.5116 7.37774 18.4337 7.29459L14.8115 3.56274V18.8453C14.804 19.0706 14.7119 19.2841 14.5546 19.4407C14.3974 19.5973 14.1873 19.6848 13.9686 19.6848C13.7499 19.6848 13.5398 19.5973 13.3826 19.4407C13.2253 19.2841 13.1332 19.0706 13.1257 18.8453V3.56274L9.5065 7.29459C9.3457 7.44191 9.13643 7.52041 8.9214 7.51408C8.70636 7.50775 8.50178 7.41705 8.34941 7.26051C8.19704 7.10397 8.10837 6.89338 8.1015 6.67173C8.09464 6.45009 8.17009 6.2341 8.31246 6.06785L13.3751 0.849045Z"
							fill="#E6B401" />
					</svg>
				</span>
			</button>
		</div>

	</pmd-navbar-right-icon>
</div>